<div>
  <div class="header rounded-lg flex flex-row items-center sticky top-0 asset-details z-50">
    <div class="title w-3/5 font-bold text-xl" i18n>TAGS</div>
    <div class="actions w-2/5 text-right">
      <button *ngIf="AnyGlobal | can: 'dashboard.editkeywords'" mat-icon-button class="cursor-pointer" role="button" i18n-matTooltip matTooltip="Edit dashboard tags" (click)="editInformation()">
        <mat-icon class="material-icons-outlined">edit</mat-icon>
      </button>
    </div>
  </div>
  <div class="public-collections">
    <div class="mr-4 h-full pt-3">
      <div class="w-full h-[88%]">
        <!-- To show loading message, while http call is in progress -->
        <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
        <ng-template #loadingComplete>
          <ng-container *ngIf="keywordDataLoaded && keywordData.length">
            <sp-chips-listbox-option [dataSource]="keywordData" [chipViewMode]="'view'" (selectedChips)="clickOnChip($event)"></sp-chips-listbox-option>
          </ng-container>
          <ng-container *ngIf="keywordDataLoaded && !keywordData.length">
            <p i18n>No Tags selected</p>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</div>
